// extracted by mini-css-extract-plugin
export default {"blur-loading__item":"zcxGl","blur-loading__placeholder":"lbyIl"};